<template>
	<div class="form-group" :class="className">
		<label class="form-label" v-show="label">{{ label }}</label>
		<select
			class="form-select"
			:class="{ active: model !== '' }"
			id="form-select-store"
			v-model="model"
			@change="setStore()"
		>
			<option value="">{{ placeholder }}</option>
			<template v-for="option in options" :key="option">
				<option :value="option.storeKey" :selected="option.storeKey === model">
					{{ refData[option.storeKey] }}
				</option>
			</template>
		</select>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormSelectStore',
	data() {
		return {
			model: ''
		}
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		className: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: '- Alle -'
		},
		refData: {
			type: Object,
			required: true
		},
		showZero: {
			type: Boolean,
			required: false,
			default: true
		},
		disableZero: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	computed: {
		options() {
			return [
				{
					storeKey: '5fe1d1644df5c04612a6240e',
					storeValue: 'hc-herne'
				},
				{
					storeKey: '60c267eebcd087023816e00b',
					storeValue: 'hc-castrop'
				},
				{
					storeKey: '60c267eebcd087023816e00c',
					storeValue: 'hc-bochum'
				},
				{
					storeKey: '60c267eebcd087023816e00d',
					storeValue: 'hc-recklinghausen'
				},
				{
					storeKey: '60c267eebcd087023816e00e',
					storeValue: 'hc-datteln'
				},
				{
					storeKey: '60c267eebcd087023816e011',
					storeValue: 'hc-oer-erkenschwick'
				},
				{
					storeKey: '60c267eebcd087023816e010',
					storeValue: 'hc-dinslaken'
				},

				{
					storeKey: '60c267eebcd087023816e012',
					storeValue: 'hc-luedinghausen'
				},
				{
					storeKey: '66910a5386d7cb3dd3ced1c1',
					storeValue: 'hc-haltern'
				},
				// {
				// 	storeKey: '66f522eec92e2665d8a6b91f',
				// 	storeValue: 'hc-duesseldorf',
				// },
				{
					storeKey: '60c267eebcd087023816e00f',
					storeValue: 'fca-datteln'
				},
				{
					storeKey: '66043603cbb387ce2ec00cd4',
					storeValue: 'dd-castrop'
				}
			]
		}
	},
	methods: {
		setStore() {
			if (this.model !== '') {
				store.commit('setStore', this.model)
			} else {
				store.commit('setStore', false)
			}
			this.$emit('updateFilter')
		}
	},
	created() {
		if (store.state.storeId) {
			this.model = store.state.storeId
		}

		this.unsubscribe = store.subscribe((mutation, state) => {
			if (mutation.type === 'setStore') {
				if (state.storeId === false && this.model !== '') {
					this.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	}
}
</script>
